import WoxIcon from "../../assets/icons/logo.svg";
import "./notfound.scss";

export default function NotFound() {
  return (
    <div id="not-found">
      <div className="not-found-header">
        <a href="https://safemutual.com/" target="_blank">
          <img className="branding-header-icon" src={WoxIcon} alt="WoxDAO" />
        </a>

        <h2 style={{ textAlign: "center" }}>Page not found</h2>
      </div>
    </div>
  );
}
